import { formatISO, startOfDay, sub } from 'date-fns';

// 処方箋期限に合わせて4日前から
export const BASE_DATE = formatISO(sub(startOfDay(new Date()), { days: 4 }));
// エラー通知は7日前から
export const ERROR_BASE_DATE = formatISO(sub(startOfDay(new Date()), { days: 7 }));
// 当日を前提にしているので1日前から
export const UBER_DELIVERY_DATE = formatISO(sub(startOfDay(new Date()), { days: 1 }));
